export default "__VITE_ASSET__Cr0Zu4XC__"